var exports = {
  "sq": "suggestionsList__aRXfoj",
  "Ol": "suggestionItem__Yy9FxS",
  "Bi": "suggestionButton__82NViN",
  "IY": "suggestionContent__36HFYE",
  "Av": "suggestionIcon__pBO-KK",
};

module.exports = exports;
